module.exports = __webpack_public_path__ + "img/GN.ff0d944a.svg";